import { getAreas } from '../../../api/serverRequests';
import { handleCachedApiRequest } from '../../../utils/cacheUtils';

export default function AreaOptionsAPI(setAreaOptionsQuery, page, localKey, userId = null) {
	const transformAreas = (data) =>
		data.areas.map((item) => ({
			label: item,
			value: item
		}));

	handleCachedApiRequest(getAreas, transformAreas, setAreaOptionsQuery, localKey, page, userId);
}
